import { useMemo } from 'react';
import {
  AlertDialog,
  AlertDialogPrimaryAction,
  AlertDialogSecondaryAction,
} from '@frameio/vapor';
import TEXT from './generated/TEXT/ConfirmUploadLinkShareDialog';

TEXT.DEFINE({
  /** Dialog title warning that the folder being shared has active upload links */
  title: 'This folder has active Upload Links',
  /** Dialog description explaining that share viewers can see uploaded assets */
  description:
    'If you create a Share Link, recipients will be able to view any uploaded assets.',
  /** Button label to cancel the Share creation */
  cancel: 'Cancel',
  /** Button label to confirm and continue sharing */
  confirm: 'Share Anyway',
});

/**
 * Confirmation dialog shown before sharing a folder that has an active upload
 * link. Mirrors {@link ConfirmCreateShareDialog} (restricted items) so the two
 * share-risk confirmations look and behave identically.
 *
 * @param props.isShowing - Whether the dialog is currently visible
 * @param props.onConfirm - Receives the user's choice (true confirm, false cancel)
 */
export const ConfirmUploadLinkShareDialog = ({
  isShowing,
  onConfirm,
}: {
  isShowing: boolean;
  onConfirm: (result: boolean) => void;
}) => {
  const textCancel = TEXT.cancel;
  const textConfirm = TEXT.confirm;

  const actions = useMemo(() => {
    return (
      <>
        <AlertDialogSecondaryAction onClick={() => onConfirm(false)}>
          {textCancel}
        </AlertDialogSecondaryAction>
        <AlertDialogPrimaryAction onClick={() => onConfirm(true)}>
          {textConfirm}
        </AlertDialogPrimaryAction>
      </>
    );
  }, [onConfirm, textCancel, textConfirm]);

  return (
    <AlertDialog
      actions={actions}
      details={TEXT.description}
      hasOutermostTheme={true}
      isShowing={isShowing}
      title={TEXT.title}
      variant="notice"
    />
  );
};
